module.exports = __webpack_public_path__ + "img/mobile_word.79c8bbfa.jpg";